import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { getMeAsyncThunk } from 'store/users/users.action';
import { clearUser } from 'store/users/users.slices';

export const updateCurrentUserDataMiddleware =
  (store) => (next: Dispatch<UnknownAction>) => (action: UnknownAction) => {
    switch (action.type) {
      case 'users/login/fulfilled':
      case 'users/refresh/fulfilled':
      case 'users/googleAuth/fulfilled':
        store.dispatch(getMeAsyncThunk());
        break;
      case 'users/logout/fulfilled':
      case 'users/logout/rejected':
        store.dispatch(clearUser());

        break;
      default:
        break;
    }
    return next(action);
  };
